<div class="containerReturnsAddEdit row">
  <div class="fulfillmentLanding create-return-outer" (window:resize)="onresize($event)">
    <div class="create-return-page">
      <div class="page-head xs-mt-15">
        <h3 class="d-flex align-items-center">Container Returns</h3>
        <p>Filter return request by choosing the type of the filter you'd like to use and searching for a value. You may opt to view submitted returns on the tab below, or see your saved drafts by selecting return request drafts tab.</p>
      </div>
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" routerLink="/container-returns/dashboard-products">Container Returns</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span>{{breadcrumbtext}}</span>
            </li>
          </ol>
        </nav>
      </div>

      <div class="returnTop xs-mb-5">
        <div *ngIf="createRequestAccess">
          <div class="row">

            <!--Sold To Select List-->
            <div class=" col-md-6 material-select arrow-remove withBordr" [class.cpp-create-soldTo]="!soldToAccount">
              <ng-select name="ddlSoldTo"
                         [items]="soldToFacility"
                         class="custom-select-grower grower-add-drop"
                         [class.ng-select-disabled]="!soldToAccount"
                         [virtualScroll]="true"
                         [(ngModel)]="soldToAccount"
                         bindLabel="accountNameCityState"
                         [disabled]="true"
                         bindValue="accountNumber"
                         placeholder="Sold To: (Will Display after selection of Ship To):"
                         [loading]="soldToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn">
                <ng-template ng-label-tmp let-item="item" let-index="index">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-12  mb-2">
                        <div class="mb-0 mt-2">
                          {{item.accountName}}
                        </div>
                        <div class="mb-0">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="mb-0">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div class="border-line pb-2">
                          Account To #: {{item.accountNumber}}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-6 mb-2">
                        <div class="name mb-0">
                          {{item.accountName}}
                        </div>
                        <div class="address  mb-0">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="phoneNo mb-0">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div class="grower-nos mb-2">
                          <span class="grower-gln">
                            Account To #: {{item.accountNumber}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <div class=" col-lg-6 col-md-6 material-select withBordr required">
              <ng-select name="ddlShipTo"
                         [items]="shipToAccountItems"
                         class="custom-select-grower grower-add-drop cpp-return-shipto"
                         [virtualScroll]="true"
                         [(ngModel)]="shipToAccount"
                         bindLabel="accountNameCityState"
                         [disabled]="isEditMode || readOnlyAccess"
                         bindValue="accountNumber"
                         placeholder="Ship To:"
                         [loading]="shipToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         (change)="getShipTo($event)"
                         (clear)="getShipTo($event)">
                <ng-template ng-label-tmp let-item="item" let-index="index">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-12 mb-2">
                        <div class="mb-0 mt-2">
                          {{item.accountName}}
                        </div>
                        <div class="mb-0">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="mb-0">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div class="border-line pb-2">
                          Account To #: {{item.accountNumber}}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <div class="col-lg-3 col-md-6 required-input-field" hidden>
              <mat-form-field class="wide100">
                <mat-label>DSM :</mat-label>
                <input [disabled]="isEditMode || readOnlyAccess || showSubmitToJde" readonly matInput type=text name="dsm"
                       autocomplete="off"
                       [(ngModel)]="dsmInfo"
                       value="dsmInfo" />
              </mat-form-field>
            </div>
            <div class=" col-lg-3 col-md-6 material-select withBordr" hidden>
              <ng-select name="ddlOnBahlfOf"
                         [items]="requestOnBehalfList"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="onBehalfUser"
                         bindLabel="userName"
                         [disabled]="readOnlyAccess || showSubmitToJde"
                         placeholder="Request on Behalf of:"
                         bindValue="userId"
                         (change)="setUserEmail($event)"
                         [closeOnSelect]="true">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.userName}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-lg-3 col-md-6 required-input-field" hidden>
              <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
                <mat-label>Email:</mat-label>
                <input matInput type="email" name="accountEmail"
                       [(ngModel)]="accountEmail"
                       [readonly]="readOnlyAccess"
                       [disabled]="showSubmitToJde"
                       [pattern]="emailPattern"
                       (keyup)="validateEmail()"
                       (input)="hasEmailAddressChanged();"
                       email="true">
                <mat-error *ngIf="isNotValid">
                  Email not valid.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!--Pickup Information Section-->
      <div class="returnTop xs-pb-0">
        <h6 class="form-group-title d-flex justify-content-between xs-mb-0">
          Pickup Information: <span class="verbiage xs-ml-5 flex-one">(*Required)</span> <span (click)="togglePickup()" class="xs-expand-none xs-mr-20"
                                                                                               [ngClass]="!isAddProductEnable ? 'disabled-icon' : ' '">
            <i class="fa angle" [ngClass]="isExpanded ? 'fa-angle-down' : 'fa-angle-up'"></i>
          </span>
        </h6>
        <div class="row" [@detailExpand]="isExpanded ? 'collapsed' : 'expanded'">
          <div class="col-lg-2 col-md-6">
            <div class="text-center deliveryDatePicker required-input-field">
              <mat-form-field>
                <mat-label>Desired Pickup Date</mat-label>
                <input matInput [matDatepicker]="picker" (focus)="picker.open();" [matDatepickerFilter]="dateFilter" [(ngModel)]="desiredPickupDate" [min]="minDate" #dateName="ngModel"
                       name="dateName" oninput="this.value=this.value.replace(/[^0-9/]/g,'');" [disabled]="showSubmitToJde"
                       required (change)="desiredPickupDateValid(dateName)" (dateChange)="ValidateSelectedDesiredPickupDate($event)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker (opened)="onOpen()">
                </mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 ">
            <div class="required-input-field">
              <mat-form-field class="wide100">
                <mat-label>Contact Name :</mat-label>
                <input matInput type=text name="Contact Name"
                       autocomplete="off"
                       [(ngModel)]="contactName"
                       maxlength="15"
                       required
                       #name="ngModel"
                       (change)="nameShouldBeValid(name)"
                       [disabled]="showSubmitToJde" />
              </mat-form-field>
            </div>
            <div class="required-input-field">
              <mat-form-field class="wide100">
                <mat-label>Contact Number :</mat-label>
                <input matInput type=text name="Contact Number"
                       autocomplete="off"
                       [(ngModel)]="contactNumber"
                       required
                       mask="000-000-0000"
                       #phone="ngModel"
                       (change)="phoneShouldBeValid(phone)"
                       [disabled]="showSubmitToJde" />
                <mat-error *ngIf="phone.invalid && (phone.dirty || phone.touched)">Please enter a 10 digit phone number</mat-error>
              </mat-form-field>
            </div>
            <div class="not-required-input">
              <mat-form-field class="wide100">
                <mat-label>Customer PO Number :</mat-label>
                <input matInput type=text name="Customer PO Number"
                       autocomplete="off"
                       [(ngModel)]="customerPONumber"
                       maxlength="25"
                       (input)="enablePlaceOrderAndSaveOrderDraft();" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 material-select withBordr not-required-select" [class.cpp-create-soldTo]="!deliverToAnotherLocation">
            <ng-select name="ddlDeliveryAccount"
                       [items]="deliveryAccountList"
                       class="custom-select-grower  grower-add-drop pb-0"
                       [virtualScroll]="true"
                       [(ngModel)]="deliveryAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [disabled]="!deliverToAnotherLocation"
                       placeholder="Pickup Location:"
                       [loading]="shipToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       (change)="getDefaultDeliveryDate($event)"
                       (clear)="getDefaultDeliveryDate($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}}, {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div>
              <mat-checkbox class="custom-checkbox pr-2"
                            [disabled]="readOnlyAccess"
                            [style.display]=""
                            [checked]=""
                            [indeterminate]=""
                            (change)="UpdateDeliverToSelection($event.checked)"
                            [(ngModel)]="deliverToAnotherLocation"></mat-checkbox>
              <label class="checkbox-color">If Pickup Location is different than Ship To.</label>
            </div>
            <div>
              <label for="specialInst" class="checkbox-color mb-0">Shipping Instructions:</label>
              <mat-form-field class="example-full-width specialInst mt-0" floatLabel="never">
                <textarea style="resize: none; height: auto;" matInput rows="6"
                          [(ngModel)]="shippingInstructions"
                          appearance="fill"
                          [maxLength]="500"
                          [readonly]="readOnlyAccess"
                          placeholder="up to 500 characters"
                          [disabled]="showSubmitToJde"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-lg-4 col-md-6 material-select withBordr">
            <div class="freight-dd">
              <label>Freight Instructions:</label>
              <div class="dd-scroll">
                <mat-selection-list #freightInstructionCtrl [(ngModel)]="selectedFreightInstructionOptions">
                  <mat-list-option *ngFor="let item of freightInstruction" [value]="item">
                    {{item.value}}
                  </mat-list-option>
                </mat-selection-list>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="returnDetail">
        <!--Product Detail section-->
        <div class="addProdContent">

          <div class="grower-add-sec seed-return-filter">
            <div *ngIf="!readOnlyAccess" class="row listing-action-items grower-page mt-4">
              <div class="col-lg-10 col-md-9 pl-4">
                <mat-checkbox *ngIf="isAddProductEnable" #AllProductCheck class="custom-checkbox select-all-check mt-1"
                              [checked]="isAllProductChecked"
                              [style.display]="disablecheckbox ? 'none' : 'block'"
                              [indeterminate]="checkBoxCount > 0 && !isAllProductChecked"
                              (change)="enableAllCheckBoxes(!isAllProductChecked)"
                              title="Select All Lines"></mat-checkbox>
                <div class="product-filter-outer">
                  <app-filter *ngIf="!showTabs" [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
                </div>

                <div class="product-tools-tab mt-1" *ngIf="showTabs && (!isSearchClicked && editToolKit)" appClickOutside (clickOutside)="tabNode=''">
                  <div class="tab-bar">
                    <ul>
                      <li *ngIf="(isValidLineStatus && !readOnlyAccess)" (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete Products" [matTooltipPosition]="'above'">
                        <i class="icon-ico-trash"></i>
                      </li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div *ngIf="tabNode==='delete'" class="delete-product">
                      <div class="tab-content-heading">
                        For: {{selectedAccountName}}
                      </div>
                      <div class="tab-content-detail">
                        <p>Are you sure you want to delete <span> {{checkBoxCount}} </span> selected Items(s)?</p>
                        <div class="btn-area">
                          <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',true)">Yes</button>
                          <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',false)">No</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-3 text-right pr-0 pl-0">
                <div class="row">
                  <div class="col-md-2 text-left padding-l0">
                    <!--<ul class="padding-t10">
                      <li *ngIf="checkBoxCount>0 && isSearchClicked" (click)="isSearchClicked=false;clearAllFilter();">
                        <i class="icon-ico-Close" matTooltip="Close" [matTooltipPosition]="'above'"></i>
                      </li>
                    </ul>-->
                  </div>
                  <div class="col-md-10 text-right margin-t5">
                    <button mat-raised-button class="btns mr-4 w160" [disabled]="!isAddProductEnable" *ngIf="(!readOnlyAccess)" (click)="addProduct()">Add Product</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 margin-t10">
              <div class="productTableOuter px-4 pb-4">
                <div class="tableContainer prodTableContainer" id="returnRequestView">
                  <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
                    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                      <div *ngIf="column=='checkbox'">
                      <th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
                </div>
                <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
                <div *ngIf="column=='returnType'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Return Type</th></div>
                <div *ngIf="column=='itemNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Item Number</th></div>
                <div *ngIf="column=='serialNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Lot/Serial Number</th></div>
                <div *ngIf="column=='dumpedUnits'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Return Units</th></div>

                <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="uom text-center">UOM</th></div>

                <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="uom text-center">Package Size</th></div>
                <div *ngIf="column=='notes'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Customer Notes</th></div>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="column=='checkbox'">
                    <div *ngIf="requestStatus!='DRAFT'" [ngClass]="{ 'lineitem-error': element.lineStatus =='ERROR'}" class="lineitem-symbols"></div>
                  </div>
                  <div *ngIf="column=='checkbox' && !readOnlyAccess && isAddProductEnable" class="text-center CheckBoxCol" matTooltip="Select Product" [matTooltipPosition]="'above'">

                    <mat-checkbox *ngIf="!readOnlyAccess" #SingleCheck
                                  (change)="enableCheckBoxSingle(SingleCheck._checked); element.isSelected=SingleCheck._checked;"
                                  [(ngModel)]="element.isSelected"
                                  class="custom-checkbox"></mat-checkbox>
                  </div>
                  <div *ngIf="column=='product'" class="order-info-outer">
                    <div class="order-info">
                      <p class="prod-id">{{element.itemVendorName}}</p>
                      <p class="prod-name">{{element.itemDescription}}</p>
                    </div>
                  </div>
                  <div *ngIf="column=='returnType'" class="measureUnit text-center select_box">
                    <select class='select-option' [(ngModel)]='element.returnType' (change)="onReturnTypeSelect($event,element.rowId)">
                      <option class='option' *ngFor='let returnType of returnTypeArray' [value]="returnType.id">{{returnType.value}}</option>
                    </select>
                  </div>
                  <div *ngIf="column=='itemNumber'" class="measureUnit text-center">
                    <p> {{element.itemNumber}} </p>
                  </div>
                  <!--to do : change serial number binding-->
                  <div *ngIf="column=='serialNumber'" class="measureUnit text-center">
                    <p>{{element.lotNumber}} </p>
                  </div>

                  <div *ngIf="column=='dumpedUnits'" class="quantityBlock text-center">
                    <div>
                      <button *ngIf="!readOnlyAccess" [disabled]="element.isDecreaseQtyDisable || element.isDisableQtyReturnType" class="plus-minus-btn minusBtn" (click)="unitChange('decrease',element)"> - </button>
                      <input [readonly]="readOnlyAccess" [disabled]="element.isDecreaseQtyDisable || element.isIncreaseQtyDisable || element.isDisableQtyReturnType" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.returnQuantity" maxlength="5" NumbersOnly [ngClass]="{'invalid-txt': (element.dumpedUnits==0 || element.dumpedUnits=='')}" />
                      <button *ngIf="!readOnlyAccess" [disabled]="element.isIncreaseQtyDisable || element.isDisableQtyReturnType" class="plus-minus-btn plusBtn" (click)="unitChange('increase',element)"> + </button>
                    </div>
                  </div>
                  <div *ngIf="column=='uom' && element.isShowOrginal" class="measureUnit text-center">
                    <p> {{element.um}} </p>
                  </div>
                  <div *ngIf="column=='uom' && !element.isShowOrginal" class="measureUnit text-center">
                    <p> {{element.tempunitOfMeasureSecondary}} </p>
                  </div>
                  <div *ngIf="column=='packageSize'" class="measureUnit text-center">
                    <p> {{element.packageSize}} </p>
                  </div>
                  <div *ngIf="column=='notes'" class="measureUnit text-center">
                    <textarea *ngIf="showSubmitToJde == false" [readonly]="readOnlyAccess" type="text" class="notesTxt" [(ngModel)]="element.customerNotes" maxlength="250" (input)="hasNotesChanged(element.customerNotes);"></textarea>
                    <p *ngIf="showSubmitToJde == true"> {{element.customerNotes}} </p>
                  </div>
                </td>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="inline-error" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.itemId}}_{{element.lineErrors.lotNumber}}">
                      <div class="row">
                        <div class="col-md-9">
                          <ol class="error-list">
                            <li *ngFor="let err of element.lineErrors.errors">
                              {{err.error}}
                          </ol>
                        </div>
                        <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                          <span>
                            Revert to Previous.
                            <i class="icon-ico-Reply"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element"
                    (click)="expandedElement = expandedElement === element ? null : element"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Error section on table-->
    <div class="common-error-block new-return-request" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors?.length > 0">
      <div class="row">
        <div class="col-md-2 padding-r0 errCountOuter">
          <span class="errorCounting">
            {{currentErrorRow}} of {{errorMsgs.length}}
          </span>
        </div>
        <div class="col-md-6 padding-l0 ">
          <ul class="errorMsg">
            <li *ngFor="let err of errorMsgs[index].errors">
              <p> {{err.error}}</p>
            </li>
          </ul>
        </div>
        <div class="col-md-4 button-sec text-right">
          <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
          <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>1" (click)="nextError()">Next Error</button>
        </div>
      </div>
    </div>
    <div class="SeedFulfillBtnSec">
      <div class="row padding-l20">
        <div class="col-md-6">
          <button mat-raised-button class="btns" *ngIf="!readOnlyAccess && showSubmitReturn" [disabled]="isDisableSubmitRequestBtn()" (click)="saveDraft(true)" [style.display]="'inline-block' ">Review Request</button>
          <button mat-raised-button class="btns" color="primary" *ngIf="!readOnlyAccess && showSubmitReturn" [disabled]="isDisableSaveDraftBtn()" (click)="saveDraft(false)" [style.display]="'inline-block'">Save Draft</button>
        </div>
        <div class="col-md-6 text-right" *ngIf="chatAccess">
          <span class="count" style="margin-right: 50px;">Returnable Products <span style="margin-right: 20px;">{{selectedCount}}</span></span>
        </div>
        <div class="col-md-6 text-right" *ngIf="!chatAccess">
          <span class="count">Returnable Products <span>{{selectedCount}}</span></span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
